const appearenceNone = `
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;

export default appearenceNone;